import React, { Component, useReducer } from 'react'
import { SET_USERLOGIN } from '../../types';
import PanelContext from './PanelContext';
import PanelReducer from './PanelReducer';

const PanelState = (props) => {
    const initialState = {
        userLogin: null
    }
    const [state, dispatch] = useReducer(PanelReducer, initialState);

    const setUserLogin = (e) => {
        dispatch({ type: SET_USERLOGIN, payload: e });
    };

    return (
        <PanelContext.Provider value={{
            userLogin: state.userLogin,
            setUserLogin,
        }}>
            {props.children}
        </PanelContext.Provider>
    )
}
export default PanelState;